import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import CloseIcon from '@material-ui/icons/Close';
import { ToggleActions } from '../../constants/constants';
import { toggleSwitch } from '../../actions';

class DemoContainer extends React.Component {

    handleCloseDemo = () => {
        this.props.toggleSwitch(ToggleActions.DEMO, false);
        this.setUserTutorialDate();
    }

    setUserTutorialDate = () => {
        try {
            if (this.props.demoUrl === window.full_tutorial_url && window.pending_full_tutorial) {
                window.pending_full_tutorial = false;
                fetch('/web-api/set-user-tutorial-date?tutorial_type=full');
            }
            if (this.props.demoUrl === window.last_updates_tutorial_url && window.pending_last_updates_tutorial) {
                window.pending_last_updates_tutorial = false;
                fetch('/web-api/set-user-tutorial-date?tutorial_type=last');
            }
        } catch (error) {
            console.log(error, 'No se pudo actualizar la fecha de revisión del tutorial');
        }
    }

    render() {
        if (!this.props.demo) {
            return <div></div>;
        }
        return(
            <div className='demo-container card-color'>
                <CloseIcon className='float-right cursor-pointer my-2' onClick={this.handleCloseDemo}/>
                <iframe
                    title='demo'
                    allow='clipboard-write'
                    src={this.props.demoUrl}
                    frameborder={0}
                    webkitallowfullscreen={true}
                    mozallowfullscreen={true}
                    allowfullscreen
                    style={{
                        width: '100%',
                        height: 'calc(100% - 40px)',
                    }}
                    >
                </iframe>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        demo    : state.switches.demo,
        demoUrl : state.filters.demoUrl,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(DemoContainer);